<template>
  <div style="font-size:12px;" class="has-text-left">
    <!-- translations question entitled-->
    <p>{{!typeof reponses === 'object' ? reponses + 'responses' : ''}} </p>
      <h1 style="font-weight:bold;margin-bottom:20px;" v-if="this.$store.getters.languageQuestionAdmin === 'fr'">
        {{ intitule[0] }}
      </h1>
      <h1 v-if="this.$store.getters.languageQuestionAdmin === 'en'">
        {{ intitule[1] }}
      </h1>
      <h1 v-if="this.$store.getters.languageQuestionAdmin === 'es'">
        {{ intitule[2] }}
      </h1>
      <h1 v-if="this.$store.getters.languageQuestionAdmin === 'de'">
        {{ intitule[3] }}
      </h1>
    <div
      v-if="Object.keys(reponses).length > 1"
      type="is-primary"
      :closable="false"
    >
      <div style="min-height:380px; overflow-y: auto;">
        <div v-for="(reponse, key) in reponses" :key="key">
          <p v-if="key != 'intitule'">{{ "- " }} {{ reponse }}</p>
        </div>
      </div>
    </div>
    <div v-else type="is-primary" :closable="false">
      <div style="max-height: 300px;">
        {{ $t("export.not-results") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LibreResultats',
  props: ['intitule', 'reponses', 'window']
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/LibreResultats.vue